import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import CustomButton from './CustomButton';
import PageLoader from './PageLoader/PageLoader';
import PATH from '../constants/path.const';
import { getColors } from '../../theme';

const colors = getColors();
function ErrorPage({ error, errorMessage }) {
  console.log(error);
  const { colorShades } = colors;
  const navigate = useNavigate();

  const handleClIck = () => {
    navigate(PATH.AUTH.LOGIN);
    window.location.reload();
  };

  return (
    <PageLoader>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          inset: 0,
          position: 'absolute',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          {errorMessage ? (
            <Typography sx={{ fontSize: '40px', pb: 2 }}>{errorMessage}</Typography>
          ) : (
            <>
              <Typography sx={{ fontSize: '40px' }}>
                <b>Something&#39;s Wrong here...</b>
              </Typography>
              <Typography variant="h6" sx={{ m: '14px' }}>
                {error?.error?.message
                  ? 'We encountered an issue. Please go back to the home page'
                  : "We're sorry, but something went wrong. Please go back to the home page."}
              </Typography>
            </>
          )}

          <Box style={{ mt: '100px' }}>
            <CustomButton
              onClick={handleClIck}
              sx={{
                color: colorShades.pureWhite,
                border: 'none',
                padding: '10px 20px',
                cursor: 'pointer',
              }}
            >
              Go to Home
            </CustomButton>
          </Box>
        </Box>
      </Box>
    </PageLoader>
  );
}

export default ErrorPage;
